import styled from 'styled-components';
import { COLORS } from "../../constants/constants";
import {Link as LinkS} from 'react-scroll';

export const DashSidebarContainer = styled.aside.withConfig({
    shouldForwardProp: (prop) => prop !== 'sidebar'
})`
    width: ${({ sidebar }) => (sidebar ? '200px' : '60px')};
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 20px;
    position: fixed;
    margin-top: 130px;
    margin-left: 20px;
    overflow: hidden;
    height: 85%;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    transition: 0.3s all ease-in-out;

    @media screen and (max-width: 768px) {
        width: 0px;
    }
`

export const SideMenu = styled.ul`
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    transition: 0.2s all ease-out;
    flex-grow: 1;
    padding: 10px 0;
`

export const SideItem = styled.li`
    list-style: none;
    width: 100%;
    height: 3rem;
`

export const SideLink = styled.div`
    color: ${COLORS.FIRST};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
    border-radius: 20px;
    padding: 5px 10px;
    transition: 0.2s ease-in-out;

    &:hover {
        background: rgba(255, 255, 255, 0.5);
        color: ${COLORS.FIRST};
    }
`

export const SideItemLogOut = styled.li`
    list-style: none;
    width: 100%;
    height: 3rem;
    margin-top: auto;
    margin-bottom: 10px;
`

export const SideLinkLogOut = styled.div`
    color: ${COLORS.FIRST};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 10px;
    padding: 5px 10px;
    transition: 0.2s ease-in-out;

    &:hover {
        background: ${COLORS.DANGER_BACKGROUND}AA;
        color: ${COLORS.DANGER};
        border-radius: 20px;
    }
`

export const SideLinkActive = styled.div`
    color: ${COLORS.WHITE};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    background-color: ${COLORS.FIRST};
    border-radius: 20px;
    margin-left: 5px;
    margin-right: 5px;
    padding: 5px 10px;
    margin-top: 5px;
    transition: 0.2s ease-in-out;

    &:hover {
        background-color: ${COLORS.FIRST};
    }
`

export const IconToggel = styled.div`
    width: 100%;
    margin-left: 40px;
    margin-bottom: 20px;
    margin-top: 10px;
`

export const Icon = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-left: 15px;
`

export const SideItemText = styled.div`
    margin-left: 10px
`

export const SideLinkClosed = styled.div`
    color: ${COLORS.FIRST};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
    border-radius: 20px;
    transition: 0.2s ease-in-out;

    &:hover {
        background: rgba(255, 255, 255, 0.5);
        color: ${COLORS.FIRST};
    }
`

export const SideLinkActiveClosed = styled.div`
    color: ${COLORS.WHITE};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    background-color: ${COLORS.FIRST};
    border-radius: 20px;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
    transition: 0.2s ease-in-out;

    &:hover {
        background-color: ${COLORS.FIRST};
    }
`

export const SideLinkLogOutClosed = styled.div`
    color: ${COLORS.FIRST};
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 10px;
    transition: 0.4s ease-in-out;

    &:hover {
        background: ${COLORS.DANGER_BACKGROUND}AA;
        color: ${COLORS.DANGER};
        border-radius: 20px;
    }
`